export default "__VITE_ASSET__K42cvdtv__"